import { createContext } from "react";

const PlaceMarkContext = createContext({});

export default PlaceMarkContext;
